import React from 'react';
//import _get from 'lodash.get';
import PropTypes from 'prop-types';
//import Link from 'components/Link';
import s from './MasonryLayout.scss';
import Card from '../../../../../components_v2/common/Card';
import Listingheader from '../../common/Listingheader';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder';

class MasonryLayout extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { sectionData = { items: [] } } = this.props;
    // const { sectionData } = this.props;
    const { items, data } = sectionData;
    const itemsList = data || items || [];

    return (
      <div className={`${s.section_wrapper} ${s.photowidget}`}>
        {sectionData.border &&
          sectionData.border === 'top' && (
            <InterSectionBorder border={sectionData.border} />
          )}
        <Listingheader
          headingname={sectionData.name}
          headingLink={sectionData.link}
          newga={`${sectionData.name}Section_Actions#${
            sectionData.name
          }_HeadingClick`}
        />
        <div className={`${'grid_wrapper'}`}>
          {itemsList.map((item, index) => {
            const spotlightGA =
              item.ag && item.ag === 'spotlight'
                ? `sl_${index + 1}_${item.id}`
                : null;
            if (index <= 2) {
              return (
                <div className={`${'col_l_4'}`} key={item.id}>
                  <Card
                    data={item}
                    isVerticalTile
                    isPhotoWidget
                    isLeadPhoto
                    newga={`${sectionData.name}Section_Actions#${
                      sectionData.name
                    }Click/${index}/${item.wu}`}
                    viewga={spotlightGA}
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
        <div className={`${'grid_wrapper'}`}>
          {itemsList.map((item, index) => {
            const spotlightGA =
              item.ag && item.ag === 'spotlight'
                ? `sl_${index + 1}_${item.id}`
                : null;
            if (index >= 3 && index <= 6) {
              return (
                <div className={`${'col_l_3'}`} key={item.id}>
                  <Card
                    data={item}
                    isVerticalTile
                    isPhotoWidget
                    newga={`${sectionData.name}Section_Actions#${
                      sectionData.name
                    }Click/${index}/${item.wu}`}
                    viewga={spotlightGA}
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
}
MasonryLayout.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
};

export default MasonryLayout;
